import CryptoJS from 'crypto-js';

const PASSPHRASE = import.meta.env.VITE_COOKIE_PASSPHRASE || 'default-passphrase';

export function encryptData<T>(data: T): string {
  try {
    const json = JSON.stringify(data);
    const cipherText = CryptoJS.AES.encrypt(json, PASSPHRASE).toString();
    return cipherText;
  } catch (error) {
    console.error('Failed to encrypt data:', error);
    throw error;
  }
}
